import { useState, useRef, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { motion, AnimatePresence } from 'framer-motion';
import styles from '../../styles/modules/building/BuildingProgressSelect.module.scss';

const BuildingProgressSelect = ({ content, onSelect }) => {
  const [isVisible, setVisibility] = useState(false);
  const [selected, setSelected] = useState(content.filter((value) => value.selected)[0]);

  const parentEl = useRef(null);
  const visualEl = useRef(null);
  const selectEl = useRef(null);

  const handleOutsideClick = (e) => {
    if (e.target.closest(`.${styles.select}`) !== parentEl.current) setVisibility(false);
  };

  useEffect(() => {
    document.body.addEventListener('click', handleOutsideClick);
    return () => document.body.removeEventListener('click', handleOutsideClick);
  }, []);
  useEffect(() => {
    if (visualEl.current && isVisible) {
      visualEl.current.style.left = `-${
        visualEl.current.getBoundingClientRect().width / 2 -
        parentEl.current.getBoundingClientRect().width / 2
      }px`;
    }
  }, [isVisible]);
  useEffect(() => {
    if (onSelect) onSelect(selected.value);
  }, [selected]);

  if (isMobile) {
    return (
      <button
        ref={parentEl}
        type="button"
        className={styles.select}
        onClick={() => selectEl.current.focus()}
      >
        <select
          ref={selectEl}
          onChange={(e) => {
            const selectedOption = [...e.target.options].filter((x) => x.selected)[0];
            const groupedSelected = {
              text: selectedOption.innerText,
              value: selectedOption.value
            };

            setSelected(groupedSelected);
          }}
        >
          {content.map((value, index) => (
            <option
              key={index}
              value={value.value}
              defaultValue={value.selected ? 'selected' : null}
            >
              {value.text}
            </option>
          ))}
        </select>
        <div className={styles.selectShowcase}>
          <div className={styles.selectText}>{selected.text}</div>
        </div>
      </button>
    );
  }

  return (
    <div
      ref={parentEl}
      className={styles.select}
      onMouseEnter={() => setVisibility(true)}
      onMouseLeave={() => setVisibility(false)}
    >
      <div className={styles.selectShowcase}>{selected.text}</div>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12, transition: { duration: 0.2 } }}
            className={styles.selectPicker}
            ref={visualEl}
          >
            {content.map((value, index) => (
              <button
                type="button"
                className={[styles.selectElement, value.value === selected.value && styles.selected]
                  .filter(Boolean)
                  .join(' ')}
                key={index}
                onClick={(e) => {
                  setVisibility(false);

                  if (!e.target.classList.contains(styles.selected)) setSelected(value);
                }}
              >
                {value.text}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BuildingProgressSelect;
